// extracted by mini-css-extract-plugin
export var contrastLow = "_c-1";
export var externalLink = "_c-2";
export var externalLinkIcon = "_c-3";
export var link = "_c-0";
export var linkLabel = "_c-4";